var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',_vm._g(_vm._b({},'transition-group',_vm.transitionGroupProps,false),_vm.transitionGroupEvents),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }